import {
  Link as ChakraLink,
  LinkProps as ChakraLinkProps,
  useStyleConfig,
} from '@chakra-ui/react';
import React from 'react';
import { Link as RRDLink } from 'react-router-dom';
import { Text } from './Text';

type LinkProps = ChakraLinkProps & {
  params?: string[];
};

export const Link: React.FC<LinkProps> = ({
  params,
  href,
  fontSize,
  children,
  ...props
}) => {
  const { color } = useStyleConfig('Link') as any;
  return (
    <ChakraLink cursor="pointer" as={RRDLink} to={href} {...props}>
      <Text cursor="inherit" fontSize={fontSize} params={params} color={color}>
        {children}
      </Text>
    </ChakraLink>
  );
};
